import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import DrawerMenu from "./DrawerMenu";

const DropdownNav = () => {
	const [openMenu, setOpenMenu] = useState(null); 
	const [isMobileView, setIsMobileView] = useState(false); // 모바일 뷰 여부
	const [isMenuOpen, setIsMenuOpen] = useState(false); // 햄버거 메뉴 열림/닫힘

	//모바일 뷰 여부 설정	
	useEffect(() => {
		const handleResize = () => {
			setIsMobileView(window.innerWidth <= 767);
		};

		handleResize(); // 초기 설정
		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	// 햄버거 메뉴 열기/닫기
	const toggleMobileMenu = () => {
		setIsMenuOpen((prev) => !prev);
	};

	// 특정 메뉴 열기/닫기
	const toggleMenu = (menu) => {
		setOpenMenu((prev) => (prev === menu ? null : menu));
	};

    // 솔루션 메뉴 클릭 핸들러
	// const handleNotYetClick = (e) => {
	// 	e.preventDefault(); // 기본 동작 방지
	// 	alert("준비중입니다.");
	// };

    const siteNavigationSchema = {
		"@context": "https://schema.org",
		"@type": "SiteNavigationElement",
		"name": "INISSOFT 메인 메뉴",
        "url": "https://www.inissoft.com/main",
        "hasPart": [
            {
				"@type": "SiteNavigationElement",
				"name": "회사소개 · CEO 인사말",
				"url": "https://www.inissoft.com/introduce/ceo",
				"position": 1
            },
            {
				"@type": "SiteNavigationElement",
				"name": "회사소개 · 연혁",
				"url": "https://www.inissoft.com/introduce/history",
				"position": 2
            },
            {
				"@type": "SiteNavigationElement",
				"name": "회사소개 · 수상/인증",
				"url": "https://www.inissoft.com/introduce/award",
				"position": 3
            },
            {
				"@type": "SiteNavigationElement",
				"name": "회사소개 · 사업분야",
				"url": "https://www.inissoft.com/introduce/business",
				"position": 4
            },
            {
				"@type": "SiteNavigationElement",
				"name": "솔루션 · ModelIN",
				"url": "https://www.inissoft.com/solutions/modelin",
				"position": 5
            },
            {
				"@type": "SiteNavigationElement",
				"name": "솔루션 · LinkIN",
				"url": "https://www.inissoft.com/solutions/linkin",
				"position": 6
            },
            {
				"@type": "SiteNavigationElement",
				"name": "솔루션 · OpenIN",
				"url": "https://www.inissoft.com/solutions/openin",
				"position": 7
            },
            {
				"@type": "SiteNavigationElement",
				"name": "솔루션 · CollectIN",
				"url": "https://www.inissoft.com/solutions/collectin",
				"position": 8
            },
            {
				"@type": "SiteNavigationElement",
				"name": "채용안내",
				"url": "https://www.inissoft.com/career",
				"position": 9
            },
            {
				"@type": "SiteNavigationElement",
				"name": "문의하기",
				"url": "https://www.inissoft.com/contact",
				"position": 10
            }
        ]
	};

	const itemListSchema = {
		"@context": "https://schema.org",
		"@type": "ItemList",
		"name": "INISSOFT 주요 페이지",
		"itemListElement": [
			{
				"@type": "ListItem",
				"position": 1,
				"name": "회사소개",
				"url": "https://www.inissoft.com/introduce/ceo"
			},
			{
				"@type": "ListItem",
				"position": 2,
				"name": "솔루션",
				"url": "https://www.inissoft.com/solutions/solution"
			},
			{
				"@type": "ListItem",
				"position": 3,
				"name": "채용공고",
				"url": "https://www.inissoft.com/career"
			},
			{
				"@type": "ListItem",
				"position": 4,
				"name": "문의하기",
				"url": "https://www.inissoft.com/contact"
			}
		]
	};

	return (
		<>
			<Helmet>
				<script type="application/ld+json">
					{JSON.stringify(siteNavigationSchema)}
				</script>
				<script type="application/ld+json">
					{JSON.stringify(itemListSchema)}
				</script>
			</Helmet>
			{isMobileView ? (
				<>
					<button type="button" className="btn menu" onClick={toggleMobileMenu}/>
					{isMenuOpen && (
						<>
						<div className="dim" onClick={toggleMobileMenu} /> {/* 배경 클릭 시 닫기 */}
						<DrawerMenu isMenuOpen={isMenuOpen} toggleMobileMenu={toggleMobileMenu} />
						</>
					)}
				</>
			) : (
			// 데스크톱 뷰: 드롭다운 메뉴
			<nav className="nav">
				<ul className="nav-group">
					{/* 회사소개 메뉴 */}
					<li
						className={`nav-item ${openMenu === "about" ? "open" : ""}`}
						onMouseEnter={() => toggleMenu("about")}
						onMouseLeave={() => toggleMenu(null)}
					>
					회사소개
					{openMenu === "about" && (
						<ul className="dropdown">
							<li>
								<Link to="/introduce/ceo">CEO 인사말</Link>
							</li>
							<li>
								<Link to="/introduce/history">연혁</Link>
							</li>
							<li>
								<Link to="/introduce/award">수상 · 인증</Link>
							</li>
							<li>
								<Link to="/introduce/business">사업분야</Link>
							</li>
						</ul>
					)}
					</li>

					{/* 솔루션 메뉴 */}
					<li
						className={`nav-item ${openMenu === "solutions" ? "open" : ""}`}
						onMouseEnter={() => toggleMenu("solutions")}
						onMouseLeave={() => toggleMenu(null)}
					>
                        <Link to="/solutions/solution">솔루션</Link>

                        {openMenu === "solutions" && (
                            <ul className="dropdown">
                                <li>
                                    <Link to="/solutions/modelin">ModelIN</Link>
                                </li>
                                <li>
                                    <Link to="/solutions/linkin">LinkIN</Link>
                                </li>
                                <li>
                                    <Link to="/solutions/openin">OpenIN</Link>
                                </li>
                                <li>
                                    <Link to="/solutions/collectin">CollectIN</Link>
                                </li>
                            </ul>
                        )}
					</li>

					{/* 채용안내 */}
					<li className="nav-item">
						<Link to="/career">채용안내</Link>
					</li>

					{/* 문의하기 */}
					<li className="nav-item">
						<Link to="/contact">문의하기</Link>
					</li>
				</ul>
			</nav>
		)}
		</>
	);
};

export default DropdownNav;
